// CPF validation utility for Brazilian CPF numbers

/**
 * Validates a Brazilian CPF number
 * @param {string} cpf - The CPF string (can be with or without formatting)
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateCPF = (cpf) => {
  if (!cpf) return false;
  
  // Remove all non-digit characters
  const cleanCPF = cpf.replace(/[^\d]/g, '');
  
  // CPF must have exactly 11 digits
  if (cleanCPF.length !== 11) {
    return false;
  }
  
  // Check if all digits are the same (invalid CPFs like 111.111.111-11)
  if (/^(\d)\1{10}$/.test(cleanCPF)) {
    return false;
  }
  
  // Validate first check digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCPF.charAt(i)) * (10 - i);
  }
  
  let remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  
  if (remainder !== parseInt(cleanCPF.charAt(9))) {
    return false;
  }
  
  // Validate second check digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCPF.charAt(i)) * (11 - i);
  }
  
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  
  if (remainder !== parseInt(cleanCPF.charAt(10))) {
    return false;
  }
  
  return true;
};

/**
 * Formats a CPF string to the standard format (xxx.xxx.xxx-xx)
 * @param {string} cpf - The CPF string
 * @returns {string} - Formatted CPF or original string if invalid
 */
export const formatCPF = (cpf) => {
  const cleanCPF = cpf.replace(/[^\d]/g, '');
  
  if (cleanCPF.length !== 11) {
    return cpf;
  }
  
  return cleanCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};